import api from '../../../api/axios'; // tu instancia de axios

const BASE = '/v1/cuestionarios';

export function useCuestionarios() {
  const listar = (params = {}) =>
    api.get(`${BASE}/grupos-cuestionario/`, { params });

  const detalle = (id) =>
    api.get(`${BASE}/grupos-cuestionario/${id}/`);

  const crear = (data) =>
    api.post(`${BASE}/grupos-cuestionario/`, data);

  const actualizar = (id, data) =>
    api.put(`${BASE}/grupos-cuestionario/${id}/`, data);

  const eliminar = (id) =>
    api.delete(`${BASE}/grupos-cuestionario/${id}/`);

  const toggleActive = (id) =>
    api.post(`${BASE}/grupos-cuestionario/${id}/toggle_active/`);

  const duplicar = (id) =>
    api.post(`${BASE}/grupos-cuestionario/${id}/duplicar/`);

  const selectores = () =>
    api.get(`${BASE}/selectores/grupos-cuestionario/`);

  return {
    listar, detalle, crear, actualizar,
    eliminar, toggleActive, duplicar, selectores,
  };
}
